import React, { Component } from 'react';
import Link from 'react-router-dom/Link'
import './projectsidebarblock.css';

class Projectsidebarblock extends Component {

    render() {

        return (

            <Link className="projectsidebarblock" to={`/project/${this.props.slug}`}>
                <div className="projectsidebarblock__projectimage" style={{backgroundImage: `url('${this.props.image}')`}}></div>
                <div className="projectsidebarblock__projectdetails">
                    <div className="projectsidebarblock__title" dangerouslySetInnerHTML={{__html: this.props.title}}></div>
                    <div className="projectsidebarblock__projectcategories">{this.props.projectCategories.join(', ')}</div>
                </div>
            </Link>

        );
    }
}

export default Projectsidebarblock;



// WEBPACK FOOTER //
// ./src/components/projectsidebarblock/projectsidebarblock.js